import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { InvoiceNavigation } from "@/components/nabava/InvoiceNavigation";
import { errorMessage } from "@/lib/api";
import { expensePath, expenseReceipts, refundLabels, type ExpenseListItem } from "@/lib/expenseReceipts";
import { hasProcurement } from "@/lib/procurement";
import { hasInvoicePermission, invoiceMoney } from "@/lib/receivedInvoices";
import "@/components/nabava/ReceivedInvoices.css";

export function ExpensesWithoutOrderPage() {
  const { user } = useAuth(), navigate = useNavigate();
  const allowed = hasInvoicePermission(user) || hasProcurement(user, "create");
  const [refundOnly, setRefundOnly] = useState(false);
  const [rows, setRows] = useState<ExpenseListItem[] | null>(null);
  const [error, setError] = useState("");
  const [reload, setReload] = useState(0);
  useEffect(() => {
    if (!allowed) return;
    const abort = new AbortController();
    expenseReceipts.list(refundOnly, abort.signal).then((data) => {
      if (!abort.signal.aborted) { setRows(data); setError(""); }
    }).catch((cause) => {
      if (!abort.signal.aborted) setError(errorMessage(cause, "Troškovi nisu učitani."));
    });
    return () => abort.abort();
  }, [allowed, refundOnly, reload]);
  return <div className="invoice-screen space-y-4 py-4">
    <InvoiceNavigation />
    <div className="flex flex-wrap items-center justify-between gap-3">
      <h1 className="text-2xl font-bold">Troškovi bez narudžbe</h1>
      {allowed && hasProcurement(user, "create") && <Button onClick={() => navigate(`${expensePath}/novi`)}>Novi trošak</Button>}
    </div>
    {!allowed ? <p role="alert">Nemate ovlast pregleda troškova bez narudžbe.</p> : <>
      <Button variant="secondary" className={refundOnly ? "ring-2 ring-amber-500" : undefined} aria-pressed={refundOnly} onClick={() => { setRows(null); setError(""); setRefundOnly(!refundOnly); }}>
        Za povrat radniku
      </Button>
      {error ? <div><p role="alert">{error}</p><Button variant="secondary" onClick={() => setReload((value) => value + 1)}>Pokušaj ponovno</Button></div>
        : rows === null ? <p role="status">Učitavam troškove…</p>
        : rows.length === 0 ? <p>Nema troškova bez narudžbe.</p>
        : <ul aria-label="Troškovi bez narudžbe" className="space-y-2">
          {rows.map((row) => <li key={row.id}>
            <button type="button" className="w-full cursor-pointer rounded-lg border border-slate-300 bg-white p-3 text-left hover:bg-slate-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600" onClick={() => navigate(`${expensePath}/${row.id}`)}>
              <span className="flex flex-wrap items-center gap-x-3 gap-y-2">
                <span>{row.datum.split("-").reverse().join(".")}</span>
                <strong>{row.trgovina}</strong><span>{row.gradiliste}</span>
                <span>Neto {invoiceMoney(row.neto)} · bruto {invoiceMoney(row.bruto)}</span>
                <span className={`rounded-full px-3 py-1 text-sm ${row.stanje_povrata === "za_povrat" ? "bg-amber-100 text-amber-950" : "bg-green-100 text-green-950"}`}>{refundLabels[row.stanje_povrata]}</span>
              </span>
            </button>
          </li>)}
        </ul>}
    </>}
  </div>;
}
